module.exports = __webpack_public_path__ + "img/slide-24.17f26bd4.jpeg";